import { render, staticRenderFns } from "./screen-preview-overlay.vue?vue&type=template&id=161b9504&scoped=true&"
import script from "./screen-preview-overlay.vue?vue&type=script&lang=js&"
export * from "./screen-preview-overlay.vue?vue&type=script&lang=js&"
import style0 from "./screen-preview-overlay.vue?vue&type=style&index=0&id=161b9504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161b9504",
  null
  
)

export default component.exports